import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'flightNumber'
})
export class FlightNumberPipe implements PipeTransform {

  transform(flight: number): string {
    let flightNumber = (flight || '----').toString();
    while (flightNumber.length < 4) {
      flightNumber = `0${flightNumber}`;
    }
    return flightNumber;
  }

}

@NgModule({
  imports: [],
  declarations: [FlightNumberPipe],
  exports: [FlightNumberPipe]
})
export class FlightNumberPipeModule { }